<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.677 9.84398C3.677 9.33417 4.09028 8.9209 4.60008 8.9209H19.4076C19.9174 8.9209 20.3307 9.33417 20.3307 9.84398C20.3307 10.3538 19.9174 10.7671 19.4076 10.7671H4.60008C4.09028 10.7671 3.677 10.3538 3.677 9.84398Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.3584 2.76929C15.8682 2.76929 16.2815 3.18256 16.2815 3.69236V6.42628C16.2815 6.93608 15.8682 7.34935 15.3584 7.34935C14.8486 7.34935 14.4353 6.93608 14.4353 6.42628V3.69236C14.4353 3.18256 14.8486 2.76929 15.3584 2.76929Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.6472 2.76929C9.157 2.76929 9.57027 3.18256 9.57027 3.69236V6.42628C9.57027 6.93608 9.157 7.34935 8.6472 7.34935C8.1374 7.34935 7.72412 6.93608 7.72412 6.42628V3.69236C7.72412 3.18256 8.1374 2.76929 8.6472 2.76929Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.9536 5.32747C5.85609 4.4696 7.10007 4.08179 8.48638 4.08179H15.5206C16.9097 4.08179 18.1546 4.46921 19.056 5.32831C19.9643 6.19399 20.4038 7.42405 20.3999 8.86268L20.3999 8.86407L19.4769 8.86144H20.3999V8.86268V16.4435C20.3999 17.8824 19.9585 19.1135 19.0503 19.9805C18.1486 20.8412 16.9039 21.2312 15.5134 21.2312H8.48638C7.09454 21.2312 5.84856 20.8323 4.94714 19.9587C4.04113 19.0806 3.59985 17.8359 3.59985 16.3806V8.86144C3.59985 7.42153 4.04397 6.19213 4.9536 5.32747ZM6.22554 6.66555C5.7635 7.10475 5.44601 7.80365 5.44601 8.86144V16.3806C5.44601 17.4626 5.76634 18.1817 6.232 18.633C6.70225 19.0888 7.438 19.385 8.48638 19.385H15.5134C16.5702 19.385 17.3073 19.092 17.7755 18.6451C18.2372 18.2044 18.5538 17.5031 18.5538 16.4435V8.86144L18.5538 8.85882C18.5568 7.80034 18.2418 7.10262 17.7823 6.66472C17.3157 6.21996 16.5789 5.92794 15.5206 5.92794H8.48638C7.43247 5.92794 6.69472 6.21957 6.22554 6.66555Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
